// extracted by mini-css-extract-plugin
export var buttonsWrapper = "ShareSection-module--buttons-wrapper--b49d9";
export var open = "ShareSection-module--open--19428";
export var textWrapper = "ShareSection-module--text-wrapper--0985f";
export var transitionWrapper = "ShareSection-module--transition-wrapper--b6d3a";
export var wrapper = "ShareSection-module--wrapper--0efc7";